'use client'
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/context/booking/useBooking.ts
import { useContext } from "react";

// src/context/booking/context.tsx
import { createContext } from "react";
import { readCookie } from "@wbk/utils";
var defaultState = {
  event: {},
  // Guaranteed to be set from the parent
  limits: { total: 0, perSubscriptionTicketType: {} },
  subscriptionBookingLimit: {},
  isSeason: false,
  checkoutMode: "tickets",
  plainTickets: [],
  // After 10 min
  sessionEnd: Date.now() + 1e3 * 60 * 10,
  seatTickets: {
    holdToken: readCookie("holdToken") || "",
    selectedSeats: [],
    selectedTickets: []
  },
  totals: {
    gross: 0,
    gross_after_discount: 0,
    vat: 0,
    discount_total: 0,
    net: 0,
    net_after_discount: 0,
    totalFee: 0,
    withdrawn_wallet_credits: 0,
    withdrawn_saudi_rewards: 0,
    withdrawn_subscription_credits: 0
  },
  totalTickets: 0,
  checkoutLoading: false,
  merchandise: [],
  addons: []
};
var context_default = createContext(__spreadProps(__spreadValues({}, defaultState), {
  eventTickets: [],
  user: {},
  // Guarenteed to be set from the parent
  hasTicketErrors: false,
  canCheckout: false,
  userPerks: [],
  appliedPerks: [],
  addPlain: () => {
  },
  replacePlain: () => {
  },
  removePlain: () => {
  },
  addAddon: () => {
  },
  removeAddon: () => {
  },
  addSeat: () => {
  },
  removeSeat: () => {
  },
  onSeatsInitialized: () => {
  },
  setChart: () => {
  },
  setCheckoutMode: () => {
  },
  removeAllSeats: () => {
  },
  clearAll: () => {
  },
  setTicketErrors: () => {
  },
  setSlotState: () => {
  },
  selectSlot: () => {
  },
  checkout: () => __async(void 0, null, function* () {
  }),
  setFavoriteTeam: () => {
  },
  setSubscription: () => {
  },
  addMerchandiseProduct: () => {
  },
  removeMerchandiseProduct: () => {
  }
}));

// src/context/booking/useBooking.ts
var useBooking = () => {
  const context = useContext(context_default);
  return context;
};
var useBooking_default = useBooking;

export {
  defaultState,
  context_default,
  useBooking_default
};
//# sourceMappingURL=chunk-NFYYQXAH.mjs.map